import { Component, OnInit } from '@angular/core';
import { BaseDynamicFormComponent } from 'src/app/common/components/dynamic-form-v2/components/base-dynamic-form/base-dynamic-form.component';
import { BaseInputValidationServiceService } from 'src/app/common/services/base-input-validation-service.service';
import { InputFieldType } from 'src/app/common/components/dynamic-form-v2/enums/InputFieldType';
import { DynamicInputType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicInputType';
import { DynamicCardType } from 'src/app/common/components/dynamic-form-v2/enums/DynamicCardType';
import QAUsersDTO from '../dto/qaUsersDTO';
@Component({
  selector: 'app-qa-users-form-v3',
  templateUrl: './qa-users-form-v3.component.html',
  styleUrls: ['./qa-users-form-v3.component.sass']
})
export class QAUsersFormV3Component extends BaseDynamicFormComponent implements OnInit {

  qaUserRecord: QAUsersDTO = new QAUsersDTO();

  constructor(private validation: BaseInputValidationServiceService) { 
    super();
  }

  ngOnInit()
  {
    this.fields =
    [
      {
        title: "QA User Data",
        fields: [
          {
            name: "Identifier",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.TextInput],
            clearField: true,
            key: 'identifier',
            isRequired: true,
            label: 'Identifier',
          },
          {
            name: "Internal Identifier",
            inputType: DynamicInputType.BaseInputField,
            inputTypeFields: [InputFieldType.TextInput],
            clearField: true,
            key: 'internalIdentifier',
            label: 'Internal Identifier',
            isRequired: false,
          }
        ],
        type: DynamicCardType.Card
      }
    ]

    this.title = 'QA User';
    this.viewRoute = 'qa-users';
    this.isLoading = false;
  }

}
